import React from 'react';
import {AutocompleteInput} from 'components/forms/Inputs';
import {useFetch} from 'hooks/useFetchData';
import {EventType, SubEventType} from 'types/App';

const MoveToSubEventForm = ({event}: {event: EventType}) => {
  const {data: subEventsData, loading: subEventsLoading} = useFetch<{items: SubEventType[]}>('GET_LIST', 'SubEvent', {
    variables: {slug: event.slug}
  });

  const subEventOptions = React.useMemo(() => {
    return subEventsData?.items?.map((subEvent) => ({id: subEvent.id, label: subEvent.name})) || [];
  }, [subEventsData]);

  return (
    <React.Fragment>
      <AutocompleteInput fullWidth loading={subEventsLoading} name="subEventId" label="Sub Event" options={subEventOptions} />
    </React.Fragment>
  );
};

export default MoveToSubEventForm;
